import React, { useContext } from 'react'
import { NavLink } from 'react-router-dom'
import banner from '../../images/FS_Banner.jpg'
import './Banner.css'

const Banner = () => {
	//
	//
	return <img src={banner} className='banner'></img>
}

export default Banner
